import React from 'react';
import ReportingBookingArtistSuggestionsPage from '../components/ReportingBookingArtistSuggestionsPage';

const ReportingBookingArtistSuggestionsApp = (props) => (
  <ReportingBookingArtistSuggestionsPage {...props} />
);

export default ReportingBookingArtistSuggestionsApp;
